import React, { ReactElement } from 'react';
import ReferAFriendIcon from '@westwing/ui-kit/Icons/ReferAFriend';
import styled, { css } from 'styled-components';
import { underTablet } from '@westwing/ui-kit/breakPoints';
import { useClubContext } from '../hooks/ClubContext';
import { ClubLink } from '../types/clubLinksTypes';
import HeaderIconLink from 'Components/IconLink';
import { useHeaderContext } from 'Components/HeaderContext';

interface ReferAFriendProps {
    displayOnMobile: boolean;
}

const StyledHeaderIconLink = styled(HeaderIconLink)<ReferAFriendProps>`
    ${underTablet`
        ${css`
            display: ${(props: ReferAFriendProps) => (props.displayOnMobile ? 'grid' : 'none')};
        `}
    `}
`;

const ReferAFriend = ({ displayOnMobile }: ReferAFriendProps): ReactElement => {
    const { links } = useClubContext();
    const { t } = useHeaderContext();
    const {
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
            useCurrentPageType,
        },
    } = useHeaderContext();
    const { pageType } = useCurrentPageType();

    return (
        <StyledHeaderIconLink
            href={links[ClubLink.CUSTOMER_ACCOUNT_CREATE_INVITATION].path}
            data-testid="oww-header-invitation-button"
            displayOnMobile={displayOnMobile}
            data-no-overlay="true"
            aria-label={t('OwwHeader_Invite friends now')}
            onClick={() =>
                trackNonInteractiveGenericEvent('Referral Program', {
                    action: 'Referral Navigation - Click',
                    label: `${pageType}`,
                })
            }
        >
            <ReferAFriendIcon />
        </StyledHeaderIconLink>
    );
};

export default ReferAFriend;
